function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emotion/is-prop-valid/node_modules/@emotion/memoize/dist/memoize.esm.js
// module id = 1555
// module chunks = 1